import { useEffect } from "react";

const DEFAULT_TITLE = "Ege Models — Model Management · Rotterdam";

export function usePageMeta(title, description, image) {
  useEffect(() => {
    const setMeta = (sel, content) => {
      const el = document.querySelector(sel);
      if (el && content) el.setAttribute("content", content);
    };
    if (title) {
      document.title = title;
      setMeta('meta[property="og:title"]', title);
      setMeta('meta[name="twitter:title"]', title);
    }
    if (description) {
      setMeta('meta[name="description"]', description);
      setMeta('meta[property="og:description"]', description);
      setMeta('meta[name="twitter:description"]', description);
    }
    if (image) {
      const abs = image.startsWith("http") ? image : `${window.location.origin}${image}`;
      setMeta('meta[property="og:image"]', abs);
      setMeta('meta[name="twitter:image"]', abs);
    }
    return () => { document.title = DEFAULT_TITLE; };
  }, [title, description, image]);
}

/** Compact one-line credits: "Mara Visser · ph. X · st. Y · hair Z · mu W" */
export function compactCredits(work) {
  return [
    work.model_name,
    work.photographer && `ph. ${work.photographer}`,
    work.stylist && `st. ${work.stylist}`,
    work.hair && `hair ${work.hair}`,
    work.makeup && `mu ${work.makeup}`,
  ].filter(Boolean).join("  ·  ");
}
